import ProviderEditView from 'components/providers/ProviderEditView'
import Page from 'components/ui/Page'
import React from 'react'
import { useParams } from 'react-router-dom'
import ProviderView from './ProviderView'

const ProviderEditViewPage = () => {
    const { id } = useParams()
    return (
        <Page title="Edit Pro Profile">
            <ProviderEditView providerId={id} />
        </Page>
    )
}

ProviderEditViewPage.propTypes = {}

export default ProviderEditViewPage
